import { getFilesDownloadRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import FilesDownloadRankingTable from './FilesDownloadRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const FilesDownloadRanking = ({
  filterData,
  pageSize,
  countToReset,
  setIsFilesDownloadTableLoading,
  emptyText
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: filesDownloadRankingList = [], isLoading } = useQueryAPI({
    api: getFilesDownloadRanking,
    key: ['getFilesDownloadRankingList', countToReset],
    params: {
      pageNumber,
      pageSize,
      dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
      dateTo: filterData.dateTo.format('YYYY-MM-DD'),
      filterId: filterData?.productId,
    },
  });

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  useEffect(() => {
    setIsFilesDownloadTableLoading(isLoading);
  }, [isLoading]);

  return (
    <TableStyle>
      <FilesDownloadRankingTable
        dataRaw={filesDownloadRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={filesDownloadRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default FilesDownloadRanking;
